import React from 'react';

function formatStatusDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  });
}

const STATUS_STYLES = {
  scheduled: 'bg-amber-50 text-amber-800 border-amber-200',
  processing: 'bg-blue-50 text-blue-800 border-blue-200',
  sent: 'bg-blue-50 text-blue-800 border-blue-200',
  delivered: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  failed: 'bg-rose-50 text-rose-800 border-rose-200',
  skipped: 'bg-gray-100 text-gray-600 border-gray-200'
};

function buildStatusLabel(row) {
  const status = String(row?.whatsapp_flow_send_status ?? '').trim().toLowerCase();
  if (!status) return null;

  if (status === 'scheduled') {
    if (row.minutes_until_send != null && Number(row.minutes_until_send) > 0) {
      return `In ${row.minutes_until_send} min`;
    }
    const scheduledAt = formatStatusDate(row.whatsapp_flow_scheduled_at);
    return scheduledAt ? `Scheduled for ${scheduledAt}` : 'Scheduled';
  }

  if (status === 'processing') return 'Sending…';

  if (status === 'sent') {
    const sentAt = formatStatusDate(row.whatsapp_flow_sent_at);
    return sentAt ? `WhatsApp sent · ${sentAt}` : 'WhatsApp sent';
  }

  if (status === 'delivered') {
    const deliveredAt = formatStatusDate(row.whatsapp_flow_delivered_at);
    return deliveredAt ? `Delivered · ${deliveredAt}` : 'Delivered';
  }

  if (status === 'failed') return 'Failed';

  if (status === 'skipped') {
    return row.whatsapp_flow_send_error?.trim() || 'Skipped';
  }

  return status;
}

function buildTooltip(row) {
  const status = String(row?.whatsapp_flow_send_status ?? '').trim().toLowerCase();
  const parts = [];

  if (row.whatsapp_flow_scheduled_at) {
    parts.push(`Scheduled: ${formatStatusDate(row.whatsapp_flow_scheduled_at)}`);
  }
  if (row.whatsapp_flow_sent_at) {
    parts.push(`Sent: ${formatStatusDate(row.whatsapp_flow_sent_at)}`);
  }
  if (row.whatsapp_flow_delivered_at) {
    parts.push(`Delivered: ${formatStatusDate(row.whatsapp_flow_delivered_at)}`);
  }
  if (row.minutes_after_lead != null) {
    parts.push(`${row.minutes_after_lead} min after lead`);
  }
  if (row.whatsapp_flow_send_error) {
    parts.push(row.whatsapp_flow_send_error);
  }

  if (status === 'failed' && row.whatsapp_flow_send_error) {
    return row.whatsapp_flow_send_error;
  }

  return parts.length ? parts.join('\n') : undefined;
}

const WhatsAppFlowSendStatusChip = ({ row }) => {
  const status = String(row?.whatsapp_flow_send_status ?? '').trim().toLowerCase();
  if (!status) return <span className="text-gray-400 text-xs">—</span>;

  const label = buildStatusLabel(row);
  const tooltip = buildTooltip(row);
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.skipped;

  return (
    <span
      title={tooltip}
      className={`inline-flex max-w-[11rem] items-center rounded-md border px-2 py-0.5 text-[11px] font-medium truncate ${style}`}>
      {label}
    </span>
  );
};

export default WhatsAppFlowSendStatusChip;
